import '../../../styles/index.css'
import './NavBar.scss';
import Hamburger from '../../../assets/icons/Hamburger Menu Button.svg'
import Montagem from '../../../assets/icons/Logo OnPrice Branco.svg'
import Usuario from '../../../assets/icons/User Button.svg'
import MenuCategorias from '../../Menus/MenuCategorias/MenuCategorias';
import MenuUsuario from '../../Menus/MenuUsuario/MenuUsuario';
import { Link, useNavigate } from 'react-router-dom'
import { GoogleLogin } from 'react-google-login'
import { useEffect } from 'react';
import { useState } from 'react';
import { gapi } from 'gapi-script'
import { apiUser } from '../../../api/api';

function NavBar({ isLogged, setIsLogged, setEmail, email }) {

  const clientId = process.env.REACT_APP_CLIENT_ID

  const [nome, setNome] = useState()
  const [image, setImage] = useState()

  const navigate = useNavigate();

  useEffect(() => {

    function start() {
      gapi.client.init({
        clientId: clientId,
        scope: ''
      })
    }

    gapi.load('client:auth2', start)

  }, [])

  const loginGoogleSuccess = (response) => {

    const { profileObj: { givenName, email, imageUrl } } = response
    setNome(givenName)
    setEmail(email)
    setImage(imageUrl)
    setIsLogged(true)

    console.log("Login com Google efetuado com Sucesso! Usuário atual: ", response.profileObj)

    apiUser.logaUsuario(email).then((response) => {

      console.log("Login com Backend efetuado com Sucesso! Usuário atual: ", response)

    }).catch((error) => {

      console.log(error)

    })

  }

  const loginGoogleFail = (response) => {

    console.log("Login falhou: ", response)
  }

  const logoutGoogleSuccess = (response) => {
    console.log("Logout efetuado com Sucesso!")
    setNome('')
    setEmail('')
    setImage('')
    setIsLogged(false)
  }

  const pesquisaUsuario = (event) => {

    if (event.key === "Enter") {

      if (event.target.value === '') {
        return
      }

      console.log("Pesquisa de usuário: ", event.target.value)

      navigate('/Pesquisa/' + event.target.value)

      event.target.value = ''

    }

  }

  return (

    <div className='nav-bar-container'>

      <MenuCategorias />

      <MenuUsuario nome={nome} email={email} image={image} logoutGoogleSuccess={logoutGoogleSuccess} clientId={clientId} />

      <header className='header page-container'>

        <div className='nav-bar-top'>
          <button className='botao-menu-lateral' data-bs-toggle="collapse" data-bs-target="#menuLateralEsquerdo" aria-expanded="false" aria-controls="menuLateralEsquerdo">

            <img src={Hamburger} alt="Botão Hamburger" />

          </button>

          <div className="logo-container">
            <Link to="/" className="link logo" style={{ fontStyle: 'italic' }}>OnPrice</Link>
          </div>

          <Link to="/Montagem">
            <img src={Montagem} alt="Botão Montagem" />
          </Link>

          <div className='botao-conta'>

            {isLogged ? (

              <button data-bs-toggle="collapse" data-bs-target="#menuLateralDireito" aria-expanded="false" aria-controls="menuLateralDireito">

                <img src={Usuario} alt="Botão Login" />

              </button>
            ) : (<div>

              <GoogleLogin
                clientId={clientId}
                render={renderProps => (
                  <button onClick={renderProps.onClick} disabled={renderProps.disabled} id='botaoLogarComGoogle'>
                    <img src={Usuario} alt="Botão Login" />
                  </button>
                )}
                onSuccess={loginGoogleSuccess}
                onFailure={loginGoogleFail}
                referrerpolicy={"no-referrer"}
                cookiePolicy={'single_host_origin'}
                isSignedIn={true}
              />

            </div>)}

          </div>
        </div>

        <div className='barra-pesquisa'>
          <input type="text" placeholder='Estou procurando por...' className='input-pesquisa c1' onKeyDown={pesquisaUsuario} />
        </div>

      </header>

    </div>
  );
}

export default NavBar;
